import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { geolocated } from "react-geolocated";
import Location from "./Location";
import Header from "../components/Header.js";

import { useDispatch } from "react-redux";
import { createEvent, unloadLocate } from "../redux/actions/common.actions";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

function Locate(props) {
  let { key } = useParams();
  const dispatch = useDispatch();
  // useEffect(() => {
  //   if (
  //     props.isGeolocationEnabled &&
  //     props.isGeolocationEnabled &&
  //     props.coords
  //   ) {
  //     dispatch(
  //       createEvent(key, "location", {
  //         longitude: props.coords.longitude,
  //         latitude: props.coords.latitude
  //       })
  //     );
  //     return () => dispatch(unloadLocate());
  //   }
  // }, [key]);
  const handleClick = (longitude, latitude) =>
    dispatch(createEvent(key, "location", { longitude, latitude }));

  return (
    <Translation>
      {t => (
        <div id="main">
          <Header />
          <div id="wrap">
            <div className="box">
              <h1>{t("system.project_name")}</h1>
              <Location {...props} />
              {props.isGeolocationEnabled &&
              props.isGeolocationEnabled &&
              props.coords ? (
                <button
                  type="button"
                  onClick={() =>
                    handleClick(props.coords.longitude, props.coords.latitude)
                  }
                >
                  {t("locate.report_location_button")}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: false
  },
  userDecisionTimeout: 5000
})(Locate);
